/**
 * DA Finder : quiz « Trouve ton parfum », recherche par équivalent,
 * « Même famille olfactive », carrousels et alertes « Bientôt disponible ».
 *
 * Le catalogue vient de snippets/da-catalog-json.liquid : inline sur la page du quiz,
 * sinon chargé à la demande via la Section Rendering API (sections/da-catalog-data).
 * Profils : metafield custom.quiz_profil (g = genre, f = familles, a = ambiances, s = saison).
 *
 * Version Prestige 11 (16/10/2026) : ajout au panier via les événements du thème
 * (cart:prepare-bundled-sections → cart:change), hauteur d'en-tête lue dans --header-height,
 * fiche produit : <buy-buttons> / <product-form>.
 */
(function () {
  'use strict';
  if (window.DAFinder) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KLAVIYO_COMPANY = 'RWHBne';
  var FAM = { frais: 'Frais', marin: 'Marin', floral: 'Floral', fruite: 'Fruité', gourmand: 'Gourmand', boise: 'Boisé', ambre: 'Ambré', epice: 'Épicé', oud_cuir: 'Oud & cuir' };
  var AMB = { frais: 'Frais et léger', doux: 'Doux et réconfortant', chaud: 'Chaud et enveloppant', intense: 'Intense et sensuel' };
  var GENRE = { F: 'Pour elle', H: 'Pour lui', M: 'Mixte', X: 'Pour tous' };
  var BUDGET = { lt30: 'Moins de 30 €', '30-45': '30 à 45 €', gt45: 'Plus de 45 €', X: 'Tout budget' };
  var FORMAT_RX = /\b(roll ?on|oil|huile|coffret|giftset|gift set|collection|set)\b/i;
  var ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var ICON_BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function norm(value) {
    return String(value || '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
      .replace(/œ/g, 'oe').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // « de » ou « d’ » devant un nom (Équivalent d’Angels’ Share, de Sauvage Elixir).
  function de(name) {
    return (/^[aeiouyhàâéèêëîïôöûü]/i.test(String(name || '').trim()) ? 'd’' : 'de ') + name;
  }

  function money(cents) {
    return (Number(cents || 0) / 100).toFixed(2) + '€';
  }

  // "Notes de tête : a, b|Notes de cœur : c|Notes de fond : d"
  function parseNotes(text) {
    var out = { tete: [], coeur: [], fond: [], all: [] };
    String(text || '').split('|').forEach(function (part) {
      var i = part.indexOf(':');
      if (i < 0) return;
      var label = norm(part.slice(0, i));
      var key = label.indexOf('tete') > -1 ? 'tete' : label.indexOf('fond') > -1 ? 'fond' : 'coeur';
      part.slice(i + 1).split(/,| et /).forEach(function (n) {
        n = n.trim().replace(/\.$/, '');
        if (n) out[key].push(n);
      });
    });
    out.all = out.tete.concat(out.coeur, out.fond);
    return out;
  }

  function baseName(title) {
    return norm(title).replace(/\b(roll on|oil|huile|coffret|giftset|gift set|collection|set|\d+ ?ml|x \d+)\b/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function prep(list) {
    return (list || []).filter(Boolean).map(function (p) {
      p.q = p.q || { g: 'M', f: [], a: [], s: '2' };
      p.q.f = p.q.f || [];
      p.q.a = p.q.a || [];
      p.notes = parseNotes(p.n);
      p.nn = p.notes.all.map(norm);
      p.base = baseName(p.t);
      p.fmt = FORMAT_RX.test(p.ft || p.t);
      var vol = /(\d+)\s?ml/i.exec(p.ft || '');
      p.ml = vol ? vol[1] + ' ml' : '';
      return p;
    });
  }

  var catalogPromise = null;
  function catalog() {
    if (catalogPromise) return catalogPromise;
    var inline = document.querySelector('script[data-da-catalog]');
    if (inline) {
      catalogPromise = new Promise(function (resolve) { resolve(prep(JSON.parse(inline.textContent))); });
      return catalogPromise;
    }
    catalogPromise = fetch(ROOT + '?sections=da-catalog-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('catalog'); return r.json(); })
      .then(function (json) {
        var box = document.createElement('div');
        box.innerHTML = json['da-catalog-data'] || '';
        var script = box.querySelector('script[data-da-catalog]');
        return prep(script ? JSON.parse(script.textContent) : []);
      });
    return catalogPromise;
  }

  function intersect(a, b) {
    return a.filter(function (x) { return b.indexOf(x) > -1; });
  }

  function jaccard(a, b) {
    if (!a.length && !b.length) return 0;
    var inter = intersect(a, b).length;
    var union = a.length + b.length - inter;
    return union ? inter / union : 0;
  }

  // Même jus décliné (Yara, Yara Oil, Yara Roll On), pas les flankers (Asad / Asad Zanzibar).
  function sameLine(a, b) {
    return !!a.base && a.base === b.base;
  }

  /* ---------- Quiz ---------- */

  function budgetOk(p, b) {
    var eur = p.p / 100;
    if (b === 'lt30') return eur < 30;
    if (b === '30-45') return eur >= 30 && eur <= 45;
    if (b === 'gt45') return eur > 45;
    return true;
  }

  function seasonFits(s, amb) {
    if (s === '2') return true;
    if (amb === 'frais') return s === 'pe';
    if (amb === 'chaud' || amb === 'intense') return s === 'ah';
    return true;
  }

  function scoreQuiz(p, ans) {
    var q = p.q, weight = 0, got = 0;
    if (ans.g && ans.g !== 'X') {
      weight += 3;
      if (q.g === ans.g) got += 3;
      else if (q.g === 'M' || ans.g === 'M') got += 2;
      else return null;
    }
    if (ans.a) {
      weight += 3;
      if (q.a.indexOf(ans.a) > -1) got += 3;
      else if (seasonFits(q.s, ans.a)) got += 1;
    }
    (ans.f || []).forEach(function (f) {
      weight += 3;
      if (q.f.indexOf(f) > -1 || (f === 'frais' && q.f.indexOf('marin') > -1)) got += 3;
    });
    (ans.no || []).forEach(function (x) {
      if (x === 'oud' && q.f.indexOf('oud_cuir') > -1) got -= 4;
      if (x === 'sucre' && q.f.indexOf('gourmand') > -1) got -= 3;
      if (x === 'floral' && q.f.indexOf('floral') > -1) got -= 3;
    });
    if (!budgetOk(p, ans.b)) return null;
    if (p.fmt && ans.b !== 'lt30') got -= 1.5;
    return weight ? Math.max(0, got) / weight : 0.5;
  }

  // À score égal, on préfère le parfum dont les familles sont surtout celles demandées.
  function focus(p, ans) {
    if (!ans.f || !ans.f.length || !p.q.f.length) return 0;
    return intersect(p.q.f, ans.f).length / p.q.f.length;
  }

  function rankQuiz(list, ans) {
    return list.map(function (p) {
      return { p: p, s: p.av ? scoreQuiz(p, ans) : null };
    }).filter(function (r) { return r.s !== null; }).sort(function (a, b) {
      return (b.s - a.s) || (focus(b.p, ans) - focus(a.p, ans)) || ((b.p.rc || 0) - (a.p.rc || 0));
    }).filter(function (r, i, all) {
      // Une seule déclinaison par parfum (Yara, Yara Oil, Yara Roll On… ne prennent qu'une place).
      for (var j = 0; j < i; j++) if (sameLine(all[j].p, r.p)) return false;
      return true;
    });
  }

  // Ce qui, dans les réponses, correspond vraiment au parfum.
  function why(p, ans) {
    var hits = [];
    if (ans.a && p.q.a.indexOf(ans.a) > -1) hits.push(AMB[ans.a]);
    (ans.f || []).forEach(function (f) {
      if (p.q.f.indexOf(f) > -1 || (f === 'frais' && p.q.f.indexOf('marin') > -1)) hits.push(FAM[f]);
    });
    return hits;
  }

  /* ---------- Même famille olfactive ---------- */

  function similar(list, current, count, manual) {
    if (manual && manual.length) {
      var picked = manual.map(function (h) {
        return list.filter(function (p) { return p.h === h && p.av; })[0];
      }).filter(Boolean).slice(0, count);
      if (picked.length) return picked.map(function (p) { return { p: p, common: commonNotes(p, current) }; });
    }
    return list.filter(function (p) {
      return p.h !== current.h && p.av && !p.fmt && !sameLine(p, current);
    }).map(function (p) {
      var gender = (p.q.g === current.q.g || p.q.g === 'M' || current.q.g === 'M') ? 1 : -1.5;
      var s = 0.55 * jaccard(p.nn, current.nn) + 0.35 * jaccard(p.q.f, current.q.f) + 0.1 * gender;
      return { p: p, s: s, common: commonNotes(p, current) };
    }).sort(function (a, b) { return b.s - a.s; }).filter(function (r, i, all) {
      // Une seule déclinaison par parfum (deux fiches « Barakkat Rouge 540 » ne prennent qu'une place).
      for (var j = 0; j < i; j++) if (sameLine(all[j].p, r.p)) return false;
      return true;
    }).slice(0, count);
  }

  function commonNotes(p, current) {
    var seen = {};
    return p.notes.all.filter(function (n) {
      var key = norm(n);
      if (seen[key] || current.nn.indexOf(key) < 0) return false;
      seen[key] = true;
      return true;
    }).slice(0, 4);
  }

  /* ---------- Recherche « J'ai déjà un parfum que j'adore » ---------- */

  function tokens(text) {
    return norm(text).split(' ').filter(function (t) { return t.length > 2 || /\d/.test(t); });
  }

  // Abréviations courantes tapées par les clients.
  var ALIAS = { ysl: 'yves saint laurent', mfk: 'maison francis kurkdjian', pdm: 'parfums de marly', br540: 'baccarat rouge 540',
    br: 'baccarat rouge', dg: 'dolce gabbana', jpg: 'jean paul gaultier', tf: 'tom ford', ck: 'calvin klein' };

  function expand(text) {
    return norm(text).split(' ').map(function (w) { return ALIAS[w] || w; }).join(' ');
  }

  function find(list, query) {
    var qn = expand(query);
    if (!qn) return { type: 'empty' };
    var qt = tokens(qn);
    var eq = list.filter(function (p) {
      if (!p.eq) return false;
      var e = norm(p.eq);
      var name = e.split(' ');
      return (qn.length > 2 && e.indexOf(qn) > -1) || name[0] === qn || (qt.length && qt.every(function (t) { return e.indexOf(t) > -1; }));
    });
    if (eq.length) return { type: 'eq', items: eq };
    var own = list.filter(function (p) {
      var t = norm(p.t);
      return t.indexOf(qn) > -1 || (qn.indexOf(t) > -1 && t.length > 3);
    });
    if (own.length) return { type: 'own', items: own };
    var byNote = list.filter(function (p) {
      return qt.some(function (t) { return p.nn.some(function (n) { return n.indexOf(t) > -1; }); });
    });
    if (byNote.length) return { type: 'note', items: byNote };
    return { type: 'none' };
  }

  /* ---------- Rendu : carte produit au format des cartes du thème ---------- */

  function subline(p) {
    var fams = (p.q.f || []).slice(0, 3).map(function (f) { return FAM[f] || f; });
    return fams.concat(p.ml ? [p.ml] : []).join(' · ');
  }

  // opts : badge, badgeGold, why (texte), whyHtml, big (carte « meilleur choix »)
  function card(p, opts) {
    opts = opts || {};
    var badge = opts.badge ? '<span class="da-pc__badge' + (opts.badgeGold ? ' da-pc__badge--gold' : '') + '">' + esc(opts.badge) + '</span>' : '';
    var whyLine = opts.whyHtml ? '<p class="da-pc__why">' + opts.whyHtml + '</p>' : (opts.why ? '<p class="da-pc__why">' + esc(opts.why) + '</p>' : '');
    var action = p.av
      ? '<button type="button" class="da-btn" data-da-add="' + esc(p.vid) + '">' + ICON_BAG + '<span>Ajouter au panier</span></button>'
      : '<a class="da-btn da-btn--ghost" href="' + esc(p.u) + (p.bd ? '#da-notify' : '') + '">' + (p.bd ? ICON_BELL + '<span>M’alerter du retour</span>' : 'Voir le parfum') + '</a>';
    return '<article class="da-pc">' +
      '<a class="da-pc__media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + badge +
      (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</a>' +
      '<div class="da-pc__info">' +
      (opts.label ? '<p class="da-best__label">' + esc(opts.label) + '</p>' : '') +
      '<p class="da-pc__vendor">' + esc(p.v) + '</p>' +
      '<h3 class="da-pc__title"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
      '<p class="da-pc__sub">' + esc(subline(p)) + '</p>' + whyLine +
      '<p class="da-pc__price">' + money(p.p) + (p.c > p.p ? '<s>' + money(p.c) + '</s>' : '') + '</p>' +
      '<div class="da-pc__actions">' + action + '</div></div></article>';
  }

  /* ---------- Carrousels ---------- */

  function initRail(wrap) {
    var rail = wrap.querySelector('[data-da-rail]');
    var prev = wrap.querySelector('[data-da-prev]');
    var next = wrap.querySelector('[data-da-next]');
    if (!rail || !prev || !next) return;
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
      var arrows = prev.parentNode;
      if (arrows) arrows.hidden = max <= 0;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.9, behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.9, behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    wrap.daRailUpdate = update;
    update();
  }

  /* ---------- Panier (Prestige 11) ----------
     Même parcours que le <product-form> du thème : on demande aux composants (tiroir panier) les
     sections à regrouper, on ajoute, on recharge cart.js puis on émet cart:change (baseEvent
     variant:add) : le compteur se met à jour et le tiroir s'ouvre tout seul. */

  function themeSetting(name) {
    var vars = window.themeVariables;
    return vars && vars.settings ? vars.settings[name] : undefined;
  }

  function addToCart(variantId) {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var body = new FormData();
    body.set('id', variantId);
    body.set('quantity', 1);
    body.set('sections', sections.join(','));
    body.set('sections_url', ROOT + 'variants/' + variantId);
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (json) { return { ok: r.ok, json: json }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.json && res.json.description) || 'add');
      if (themeSetting('cartType') === 'page' || themeSetting('pageType') === 'cart') {
        window.location.href = ROOT + 'cart';
        return;
      }
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (sections.length && res.json.sections) {
          cart.sections = res.json.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-da-add]');
    if (!btn) return;
    event.preventDefault();
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Ajout…';
    addToCart(Number(btn.getAttribute('data-da-add'))).then(function () {
      btn.textContent = 'Ajouté ✓';
    }).catch(function () {
      btn.textContent = 'Indisponible';
    }).then(function () {
      setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2500);
    });
  });

  /* ---------- Alerte « Bientôt disponible » (Klaviyo Back in Stock) ---------- */

  document.addEventListener('click', function (event) {
    var open = event.target.closest && event.target.closest('[data-da-alert-open]');
    if (!open) return;
    var box = open.closest('[data-da-alert]');
    var form = box && box.querySelector('form[data-da-notify]');
    if (!form) return;
    open.hidden = true;
    form.hidden = false;
    var input = form.querySelector('input[type="email"]');
    if (input) input.focus();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-da-notify]');
    if (!form) return;
    event.preventDefault();
    var box = form.closest('[data-da-alert]') || form;
    var input = form.querySelector('input[type="email"]');
    var msg = box.querySelector('[data-da-notify-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();
    if (!email || (input.checkValidity && !input.checkValidity())) {
      if (msg) msg.textContent = 'Indiquez une adresse e-mail valide.';
      input.focus();
      return;
    }
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.getAttribute('data-variant') } } }
      } })
    }).then(function (r) {
      if (r.status < 200 || r.status >= 300) throw new Error('bis');
      box.classList.add('is-done');
      if (msg) msg.textContent = '✓ C’est noté ! Vous recevrez un e-mail dès son retour.';
    }).catch(function () {
      btn.disabled = false;
      if (msg) msg.textContent = 'L’inscription n’a pas fonctionné. Écrivez-nous à contact@dubaiarabian.com, on vous prévient.';
    });
  });

  /* ---------- Bloc fiche produit ---------- */

  function initSameFamily(el) {
    var handle = el.getAttribute('data-handle');
    var manual = (el.getAttribute('data-manual') || '').split(',').filter(Boolean);
    var rail = el.querySelector('[data-da-rail]');
    function run() {
      catalog().then(function (list) {
        var current = list.filter(function (p) { return p.h === handle; })[0];
        if (!current) return;
        var items = similar(list, current, 8, manual);
        if (!items.length) return;
        rail.innerHTML = items.map(function (r) {
          return card(r.p, { whyHtml: r.common.length ? '<b>En commun :</b> ' + esc(r.common.join(', ')) : '' });
        }).join('');
        el.hidden = false;
        if (el.daRailUpdate) el.daRailUpdate();
      }).catch(function () {});
    }
    var started = false;
    function start() { if (started) return; started = true; run(); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '600px 0px' });
      io.observe(el.parentNode || el);
    }
    // Plan B : le bloc est sous la ligne de flottaison, on le prépare après le chargement de la page.
    window.addEventListener('load', function () { setTimeout(start, 2500); });
    if (document.readyState === 'complete') setTimeout(start, 2500);
  }

  /* ---------- Page du quiz ---------- */

  // Prestige 11 expose --header-is-sticky (header.liquid) et --header-height (script de l'en-tête).
  function headerOffset() {
    var rootStyle = getComputedStyle(document.documentElement);
    var sticky = parseInt(rootStyle.getPropertyValue('--header-is-sticky'), 10);
    var height = parseFloat(rootStyle.getPropertyValue('--header-height'));
    if (!isNaN(sticky) && !isNaN(height)) return sticky ? height : 0;
    var header = document.querySelector('.shopify-section--header, #shopify-section-header');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    return pos === 'sticky' || pos === 'fixed' ? header.offsetHeight : 0;
  }

  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var ans = { g: null, a: null, f: [], no: [], b: null };
    var progress = root.querySelector('[data-da-progress]');
    var order = ['q1', 'q2', 'q3', 'q4'];

    function show(name) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
      var i = order.indexOf(name);
      if (progress) {
        progress.hidden = i < 0;
        progress.querySelectorAll('i').forEach(function (bar, k) { bar.classList.toggle('is-on', k <= i); });
        var label = progress.querySelector('[data-da-progress-label]');
        if (label) label.textContent = 'Question ' + (i + 1) + ' sur 4';
      }
      var heading = root.querySelector('[data-step="' + name + '"] h1, [data-step="' + name + '"] h2');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      // Le haut du test doit passer sous l'en-tête collant du thème, pas derrière.
      var offset = headerOffset();
      var top = root.getBoundingClientRect().top;
      if (top < offset || top > window.innerHeight * 0.4) window.scrollTo({ top: window.pageYOffset + top - offset, behavior: 'smooth' });
    }

    function results() {
      catalog().then(function (list) {
        var ranked = rankQuiz(list, ans);
        var note = '';
        if (ranked.length < 3 && ans.b && ans.b !== 'X') {
          ranked = rankQuiz(list, { g: ans.g, a: ans.a, f: ans.f, no: ans.no, b: 'X' });
          note = '<p class="da-note">Peu de parfums dans ce budget : voici les plus proches de ton profil, tous budgets confondus.</p>';
        }
        var chips = [GENRE[ans.g || 'X'], AMB[ans.a]].concat(ans.f.map(function (f) { return FAM[f]; }), [BUDGET[ans.b || 'X']])
          .filter(Boolean).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('');
        root.querySelector('[data-da-profile]').innerHTML = chips;
        var best = root.querySelector('[data-da-best]');
        var grid = root.querySelector('[data-da-results]');
        var moreTitle = root.querySelector('[data-da-more-title]');
        if (!ranked.length) {
          best.innerHTML = '';
          best.hidden = true;
          moreTitle.hidden = true;
          grid.innerHTML = '<p class="da-note">Aucun parfum ne correspond à toutes tes réponses. Modifie une réponse pour élargir la sélection.</p>';
        } else {
          var top = ranked[0];
          var hits = why(top.p, ans);
          best.innerHTML = card(top.p, {
            label: 'Ton meilleur choix · ' + Math.round(top.s * 100) + ' % compatible',
            whyHtml: hits.length ? '<b>Pourquoi lui :</b> ' + esc(hits.join(' · ')) : ''
          });
          best.hidden = false;
          moreTitle.hidden = ranked.length < 2;
          grid.innerHTML = note + ranked.slice(1, 9).map(function (r) {
            var h = why(r.p, ans);
            return card(r.p, { badge: Math.round(r.s * 100) + ' % compatible', why: h.length ? h.join(' · ') : '' });
          }).join('');
        }
        show('results');
      }).catch(function () {
        root.querySelector('[data-da-best]').hidden = true;
        root.querySelector('[data-da-more-title]').hidden = true;
        root.querySelector('[data-da-results]').innerHTML = '<p class="da-note">La sélection n’a pas pu se charger. <a href="' + ROOT + 'collections/all">Voir tous nos parfums</a> ou recharge la page.</p>';
        show('results');
      });
    }

    root.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-da-chip]');
      if (chip) {
        var input = root.querySelector('form[data-da-finder] input');
        input.value = chip.getAttribute('data-da-chip');
        runFinder(input.value);
        return;
      }
      var go = event.target.closest('[data-go]');
      if (go) {
        if (go.hasAttribute('data-reset')) {
          ans = { g: null, a: null, f: [], no: [], b: null };
          root.querySelectorAll('[aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        }
        show(go.getAttribute('data-go'));
        return;
      }
      var opt = event.target.closest('[data-k]');
      if (!opt) return;
      var k = opt.getAttribute('data-k'), v = opt.getAttribute('data-v');
      if (k === 'f' || k === 'no') {
        var arr = ans[k], idx = arr.indexOf(v);
        if (idx > -1) arr.splice(idx, 1);
        else if (k !== 'f' || arr.length < 3) arr.push(v);
        opt.setAttribute('aria-pressed', arr.indexOf(v) > -1 ? 'true' : 'false');
        return;
      }
      ans[k] = v;
      opt.parentNode.querySelectorAll('[data-k]').forEach(function (b) { b.setAttribute('aria-pressed', b === opt ? 'true' : 'false'); });
      if (k === 'g') show('q2');
      else if (k === 'a') show('q3');
      else if (k === 'b') results();
    });

    var finder = root.querySelector('form[data-da-finder]');
    if (finder) {
      finder.addEventListener('submit', function (event) {
        event.preventDefault();
        runFinder(finder.querySelector('input').value);
      });
    }

    function runFinder(query) {
      var out = root.querySelector('[data-da-finder-results]');
      catalog().then(function (list) {
        var r = find(list, query), html = '';
        var avail = function (items) { return items.slice().sort(function (a, b) { return (b.av - a.av) || ((b.rc || 0) - (a.rc || 0)); }); };
        if (r.type === 'eq') {
          html = '<p class="da-note">Notre équivalent pour « ' + esc(query) + ' » :</p>' +
            avail(r.items).map(function (p) { return card(p, { badge: 'Équivalent', badgeGold: true, why: 'Équivalent ' + de(p.eq) }); }).join('');
          if (!r.items.some(function (p) { return p.av; })) {
            html += '<p class="da-note">En attendant son retour, les parfums disponibles aux notes les plus proches :</p>' +
              similar(list, r.items[0], 3).map(function (x) {
                return card(x.p, { whyHtml: x.common.length ? '<b>En commun :</b> ' + esc(x.common.join(', ')) : '' });
              }).join('');
          }
        } else if (r.type === 'own') {
          html = avail(r.items).slice(0, 6).map(function (p) { return card(p); }).join('');
        } else if (r.type === 'note') {
          html = '<p class="da-note">Nos parfums avec « ' + esc(query) + ' » dans leurs notes :</p>' +
            avail(r.items).filter(function (p) { return p.av; }).slice(0, 9).map(function (p) { return card(p); }).join('');
        } else if (r.type === 'none') {
          html = '<p class="da-note">Nous n’avons pas encore d’équivalent référencé pour « ' + esc(query) + ' ». ' +
            'Essaie une note que tu aimes (vanille, oud, rose…) ou <button type="button" class="da-link" data-go="q1" data-reset>fais le test en 4 questions</button>.</p>';
        }
        out.innerHTML = html;
      });
    }

    var params = new URLSearchParams(window.location.search);
    if (params.get('q')) {
      root.querySelector('form[data-da-finder] input').value = params.get('q');
      show('finder');
      runFinder(params.get('q'));
    } else if (params.get('start')) {
      show('q1');
    }

    // Suggestions : les équivalents référencés, puis quelques notes recherchées.
    catalog().then(function (list) {
      var dl = root.querySelector('#da-finder-list');
      var chipsBox = root.querySelector('[data-da-chips]');
      var seen = {}, opts = [], chips = [];
      // Suggestions rapides : d'abord les équivalents des parfums disponibles les plus notés.
      list.slice().sort(function (a, b) { return (b.av - a.av) || ((b.rc || 0) - (a.rc || 0)); }).forEach(function (p) {
        var eqName = p.eq && p.eq.split(' (')[0];
        if (eqName && !seen[eqName]) { seen[eqName] = true; chips.push(eqName); }
        [eqName, p.t].forEach(function (name) {
          if (name && !seen['o:' + name]) { seen['o:' + name] = true; opts.push('<option value="' + esc(name) + '">'); }
        });
      });
      if (dl) dl.innerHTML = opts.join('');
      if (chipsBox) {
        chipsBox.innerHTML = chips.slice(0, 7).concat(['Vanille', 'Oud', 'Rose', 'Safran']).map(function (c) {
          return '<button type="button" class="da-chip" data-da-chip="' + esc(c) + '">' + esc(c) + '</button>';
        }).join('');
      }
    });
  }

  window.DAFinder = { catalog: catalog, card: card, find: find, similar: similar, rankQuiz: rankQuiz };

  // Fiche produit d'un parfum « Bientôt disponible » : alerte sous les boutons d'achat, libellé du bouton.
  // Prestige 11 : <buy-buttons> dans <product-form> ; ancien thème : .ProductForm (gardé en secours).
  function initPdpNotify(box) {
    var anchor = document.querySelector('buy-buttons') || document.querySelector('product-form') || document.querySelector('.ProductForm');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.hidden = false;
    var atc = document.querySelector('buy-buttons button[type="submit"][disabled], .ProductForm__AddToCart[disabled]');
    if (atc) atc.textContent = 'Bientôt disponible';
  }

  function boot() {
    document.querySelectorAll('[data-da-quiz]').forEach(initQuiz);
    document.querySelectorAll('[data-da-rail-wrap]').forEach(initRail);
    document.querySelectorAll('[data-da-same-family]').forEach(initSameFamily);
    document.querySelectorAll('[data-da-pdp-notify]').forEach(initPdpNotify);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
